<template>
  <section class="flex min-h-screen flex-col lg:flex-row">
    <div
      ref="leftDiv"
      class="relative z-0 flex-col overflow-hidden border-rose-500 bg-muted p-12 lg:w-1/2 xl:px-32 xl:py-36"
    >
      <slot name="leftSection"></slot>
      <div
        :class="`absolute inset-x-2/3 -top-1/3 bg-yellow-300 w-full aspect-square rounded-full blur-[400px] opacity-60`"
      />
      <div :class="`absolute w-full aspect-square bg-pink-400 -left-3/4 inset-2/3 rounded-full blur-3xl opacity-80`" />
    </div>
    <div ref="rightDiv" class="h-screen bg-white p-12 lg:w-1/2">
      <slot name="rightSection"></slot>
    </div>
  </section>
</template>
